import React, {useRef, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis, faX } from '@fortawesome/free-solid-svg-icons';
import { Button, ListGroup, OverlayTrigger, Popover } from 'react-bootstrap';

const ShowMenuButton = ({ menuItems }) => {
    const [show, setShow] = useState(false);
    return (
        <OverlayTrigger show={show} placement="bottom" rootClose={false} onHide={()=>setShow(false)} overlay={
            <Popover id="popover-positioned-bottom">
                <div style={{paddingTop:5, paddingRight:10,textAlign:'right'}}><FontAwesomeIcon icon={faX} style={{cursor:'pointer'}} onClick={()=> setShow(false)} /></div>
                <ListGroup style={{ minWidth: '12rem', padding: 8 }}>
                    {menuItems?.filter(item => typeof item === 'object' && item !== null)?.map((m, index) => {
                        return (
                            <ListGroup.Item 
                                key={index}
                                disabled={m.disabled}
                                className={`d-flex align-items-center border-0 px-0 ${m.name ? 'hover-highlight' : ''}`}
                                style={{
                                    height: 25,
                                    cursor: m.name ? 'pointer' : 'default',
                                    paddingLeft: 8
                                }}
                                onClick={(e) => { e.stopPropagation(); setShow(false); m.onClick && m.onClick(m.name, m.target) }}>
                                {m.icon && <span style={{ marginRight: 5 }}>{m.icon}</span>}
                                <span>{m.name}</span>
                            </ListGroup.Item>
                        );
                    })}
                </ListGroup>
            </Popover >
        }>
            <Button variant="light" className="border px-3 py-1" style={{ borderRadius: '6px' }} onClick={()=> setShow(true)}>
                <FontAwesomeIcon icon={faEllipsis} />
            </Button>
        </OverlayTrigger >
    );
};

export default ShowMenuButton;
